import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/admin/AdminLayout';
import DataTable from '../../components/admin/DataTable';
import api from '../../utils/api';
import './TherapistListPage.css';

const AdminTherapistListPage = () => {
  const navigate = useNavigate();
  const [therapists, setTherapists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTherapists();
  }, []);

  const fetchTherapists = async () => {
    try {
      const res = await api.get('/therapists/admin');
      setTherapists(res.data);
    } catch (error) {
      console.error('Failed to fetch therapists:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm('Are you sure you want to deactivate this therapist?')) return;
    try {
      await api.delete(`/therapists/${id}`);
      fetchTherapists();
    } catch (error) {
      console.error('Failed to delete therapist:', error);
      alert('Failed to delete therapist');
    }
  };

  const columns = [
    { key: 'id', label: 'ID', width: '60px' },
    { key: 'name', label: 'Name' },
    { key: 'nameKo', label: 'Name (KO)' },
    { key: 'locationId', label: 'Location' },
    { key: 'age', label: 'Age', width: '60px' },
    { key: 'experience', label: 'Exp', width: '60px', render: (row) => `${row.experience}yr` },
    { key: 'rating', label: 'Rating', width: '70px', render: (row) => `⭐ ${row.rating}` },
    {
      key: 'specialtyIds',
      label: 'Specialties',
      render: (row) => (row.specialtyIds || []).join(', '),
    },
    {
      key: 'active',
      label: 'Status',
      render: (row) => (
        <span className={`status-badge ${row.active ? 'confirmed' : 'cancelled'}`}>
          {row.active ? 'Active' : 'Inactive'}
        </span>
      ),
    },
    {
      key: 'actions',
      label: 'Actions',
      render: (row) => (
        <div className="table-actions" onClick={(e) => e.stopPropagation()}>
          <button className="table-action-btn edit" onClick={() => navigate(`/admin/therapists/${row.id}`)}>Edit</button>
          {row.active && (
            <button className="table-action-btn delete" onClick={(e) => handleDelete(row.id, e)}>Delete</button>
          )}
        </div>
      ),
    },
  ];

  if (loading) {
    return <AdminLayout><div className="admin-loading">Loading...</div></AdminLayout>;
  }

  return (
    <AdminLayout>
      <div className="admin-therapist-list-page">
        <div className="page-header-row">
          <h1>Therapists</h1>
          <button className="add-btn" onClick={() => navigate('/admin/therapists/new')}>
            + Add Therapist
          </button>
        </div>
        <DataTable
          columns={columns}
          data={therapists}
          onRowClick={(row) => navigate(`/admin/therapists/${row.id}`)}
          emptyMessage="No therapists found"
        />
      </div>
    </AdminLayout>
  );
};

export default AdminTherapistListPage;
